import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["children"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { Link, Popover, Space } from "@pochta/ui";
export var MenuUser = function MenuUser(_ref) {
  var items = _ref.items,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Popover, {
    placement: "bottom",
    trigger: "mouseenter",
    content: /*#__PURE__*/React.createElement(Space, {
      direction: "column",
      gap: 16
    }, items)
  }, children);
};
export var MenuUserItem = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Link, _extends({
    ref: ref,
    flexbox: true,
    alignItems: "center",
    underline: "none",
    color: "inherit",
    visited: false,
    size: "s"
  }, props), children);
});